/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerdownloadpdf2Inputs */

const en_flyerdownloadpdf2 = /** @type {(inputs: Flyerdownloadpdf2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download flyer as PDF`)
};

const de_flyerdownloadpdf2 = /** @type {(inputs: Flyerdownloadpdf2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer als PDF herunterladen`)
};

/**
* | output |
* | --- |
* | "Download flyer as PDF" |
*
* @param {Flyerdownloadpdf2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerdownloadpdf2 = /** @type {((inputs?: Flyerdownloadpdf2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerdownloadpdf2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerdownloadpdf2(inputs)
	return de_flyerdownloadpdf2(inputs)
});
export { flyerdownloadpdf2 as "flyerDownloadPdf" }